window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('fieldset.fieldset-radio-switch').length) {
    import('./_form-fieldset-radio-switch.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
